export const PROCESS_STEPS = [
  {
    id: "introduction",
    n: "01",
    title: "Introduction",
    tagline: "Establish the relationship",
    body: "Every engagement begins with identity. Before terms are discussed, both sides table who they are, what they hold, and what they intend — on paper, through verifiable channels.",
    docs: [
      { id: "cis", label: "Client Information Sheet (CIS)" },
      { id: "incorporation", label: "Certificate of Incorporation" },
      { id: "principal-id", label: "Passport / ID of principal signatory" },
      { id: "mandate-letter", label: "Buyer or Seller mandate letter" },
      { id: "ncnda", label: "NCNDA / NDA (where intermediaries are involved)" },
    ],
  },
  {
    id: "verification",
    n: "02",
    title: "Verification",
    tagline: "Clear compliance before commerce",
    body: "FATF-aligned KYC/AML on every principal, sanctions screening across OFAC, EU, UN and UK HMT lists, and proof that the product or the funds are real. Unverified counterparties do not advance.",
    docs: [
      { id: "kyc-pack", label: "KYC/AML pack incl. UBO declaration" },
      { id: "pof-pop", label: "Proof of Funds (bank-issued) or Proof of Product" },
      { id: "sanctions-consent", label: "Sanctions screening consent & clearance" },
      { id: "bank-coords", label: "Verifiable banking coordinates" },
      { id: "source-license", label: "Mining / export license of the source" },
    ],
  },
  {
    id: "trial-lift",
    n: "03",
    title: "Trial Lift",
    tagline: "The first documented movement",
    body: "A small, fully documented export proves the corridor. Every gram is assayed independently, insured, and tracked from mine gate to destination refinery. The trial is the audition — for both sides.",
    docs: [
      { id: "assay-report", label: "Independent assay report (XRF + fire assay)" },
      { id: "cert-origin", label: "Certificate of Origin" },
      { id: "export-permit", label: "Export permit / license" },
      { id: "invoice-packing", label: "Commercial invoice & packing list" },
      { id: "insurance", label: "Cargo insurance certificate" },
    ],
  },
  {
    id: "settlement",
    n: "04",
    title: "Settlement",
    tagline: "Funds against documents",
    body: "Payment instruments activate against presented documents — never against promises. Destination refinery assay confirms final numbers; title transfers; both sides close clean.",
    docs: [
      { id: "awb-customs", label: "Air waybill & customs export declaration" },
      { id: "instrument", label: "Payment instrument activation (SBLC / DLC / MT103)" },
      { id: "final-assay", label: "Destination refinery final assay" },
      { id: "settlement-statement", label: "Settlement statement & title transfer" },
    ],
  },
  {
    id: "ongoing",
    n: "05",
    title: "Ongoing Program",
    tagline: "Convert the trial into flow",
    body: "A clean trial converts into a rolling program: monthly allocations, a standing contract, and a performance record that makes every subsequent trade faster and better-priced. That is how trust compounds.",
    docs: [
      { id: "allocation-schedule", label: "Monthly allocation schedule" },
      { id: "spa", label: "Rolling contract / Sale & Purchase Agreement" },
      { id: "performance-review", label: "Performance & compliance review cycle" },
      { id: "license-renewals", label: "Corridor license & documentation renewals" },
    ],
  },
];

export const totalDocs = PROCESS_STEPS.reduce((n, s) => n + s.docs.length, 0);

export const verdictFor = (pct) => {
  if (pct >= 100) return { label: "Cleared for structured execution", tone: "text-[#E8C85A]" };
  if (pct >= 75) return { label: "Trial-lift ready", tone: "text-[#D4AF37]" };
  if (pct >= 40) return { label: "Verification-ready", tone: "text-zinc-300" };
  return { label: "Discovery stage — assemble your CIS pack", tone: "text-zinc-400" };
};
